import axios from "axios"

/**
    * @function allTransactionService
    * @param { organizerId, paginate, page, perPage, keyword }
    * @description This function is used to get all transaction
*/
export const allTransactionService = async({ organizerId, paginate, page, perPage, keyword }) =>{
    try {
        const result = await axios.get(`/admin/wallet/transaction-history/${organizerId}?paginate=${paginate}&page=${page}&perPage=${perPage}&keyword=${keyword}`)
        return result;
    } catch (error) {
        return error;
    }
}

